var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 80,
    height: 80,
    rx: 40,
    transform: "rotate(-90 0 80)",
    fill: "url(#paint0_linear_53_1283)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.5555 37.8104C26.589 37.8104 25.8055 38.5939 25.8055 39.5604C25.8055 40.5269 26.589 41.3104 27.5555 41.3104L27.5555 37.8104ZM54.5708 40.7979C55.2542 40.1144 55.2542 39.0064 54.5708 38.323L43.4338 27.1861C42.7504 26.5026 41.6424 26.5026 40.959 27.1861C40.2755 27.8695 40.2755 28.9775 40.959 29.6609L50.8584 39.5604L40.959 49.4599C40.2755 50.1433 40.2755 51.2514 40.959 51.9348C41.6424 52.6182 42.7504 52.6182 43.4338 51.9348L54.5708 40.7979ZM27.5555 41.3104L53.3333 41.3104L53.3333 37.8104L27.5555 37.8104L27.5555 41.3104Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_1283",
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 265.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC131"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.9945237987a65a8ef584a7a741cc38c2.svg";
export { ForwardRef as ReactComponent };